import axios from 'axios';
import { API_URL } from './config';
import { getToken } from '../services/auth/authService';

// Crear instancia global de axios
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Variable para evitar múltiples llamadas de logout
let isHandlingAuthError = false;

// Interceptor de request para agregar token automáticamente
apiClient.interceptors.request.use(
  async (config) => {
    const token = await getToken();
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de response para manejar errores de autenticación
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Solo manejar errores 401/403 si NO es una petición de login
    const isLoginRequest = error.config?.url?.includes('/auth/login/');
    
    if (!isLoginRequest && error.response && error.response.status === 401) {
      if (!isHandlingAuthError) {
        isHandlingAuthError = true;
        console.log('Error de autenticación detectado en interceptor global');
        
        // Disparar evento de token expirado
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new CustomEvent('auth:token-expired'));
        }
        
        // Reset flag después de un breve delay
        setTimeout(() => {
          isHandlingAuthError = false;
        }, 1000);
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;